import { useSyncExternalStore } from "react";
import { isDrillVisible, subscribeDrillVisible } from "../lib/drill-visibility";

/** « S'exercer » visible pour la personne connectée (interrupteur + profil, `drill-visibility.ts`). */
export function useDrillVisible(): boolean {
  return useSyncExternalStore(subscribeDrillVisible, isDrillVisible, isDrillVisible);
}
